import { Component } from '@angular/core';
// Services
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.sass']
})
export class AppComponent {
	navCollapsed: boolean = true;

	constructor(
		public afs: AngularFirestore,
		public appSvc: AppService,
		private authSvc: AuthService,
		private router: Router
	) { 
		afs.firestore.settings({ timestampsInSnapshots: false });
	}

	get navbarText() {
		let url = this.router.url;

		if (url.includes('free-trial-upgrade'))
			return 'ChildPilot Management Software';

		if (url.includes('free-trial'))
			return 'ChildPilot Management Software';

		return 'ChildPilot Sign Up'
	}

	// Log user out.
	logout(): void {
		if (confirm('Do you want to logout?')) {
			this.authSvc.logout()
				.then((value) => { })
				.catch((err) => { });
		}
	}
}